const initState = {
  followActionError: null,
  userStatustoFollow: null, //This variable checks if the user is trying to follow a profile without logging in
  userToFollowWithoutLogIn: null,
  userIdToFollowWithoutLogIn: null,
  redirectUserAfterLogIn: null,
  redirectUserAfterFollow: null,
  redirectToOverviewComp: null,
  alreadyFollowingChecked: false,
  alreadyFollowing: null
};

const supportReducer = (state = initState, action) => {
  switch (action.type) {
    case "FOLLOW_USER_SUCCESS_AFTER":
      return {
        ...state,
        redirectUserAfterFollow: true
      };
    case "FOLLOW_USER_ERROR":
      return {
        ...state,
        followActionError: action.err
      };
    case "UNFOLLOW_USER_SUCCESS":
      return {
        ...state
      };
    case "UNFOLLOW_USER_ERROR":
      return {
        ...state,
        followActionError: action.err
      };
    case "FOLLOW_WITHOUT_LOGIN":
      return {
        ...state,
        userStatustoFollow: true,
        userToFollowWithoutLogIn: action.user,
        userIdToFollowWithoutLogIn: action.userId
      };
    case "REDIRECT_AFTER_LOGIN":
      return {
        ...state,
        redirectUserAfterLogIn: true
      };
    case "RESET_REDIRECT_VARS":
      return {
        ...state,
        userStatustoFollow: null,
        userToFollowWithoutLogIn: null,
        userIdToFollowWithoutLogIn: null,
        redirectUserAfterLogIn: null,
        redirectUserAfterFollow: null,
        redirectToOverviewComp: null
      };
    case "REDIRECT_OVERVIEW":
      return {
        ...state,
        redirectToOverviewComp: true
      };
    case "SET_ALREADY_FOLLOWING":
      return {
        ...state,
        alreadyFollowingChecked: true,
        alreadyFollowing: true
      };
    case "SET_NOT_ALREADY_FOLLOWING":
      return {
        ...state,
        alreadyFollowingChecked: true,
        alreadyFollowing: false
      };
    case "RESET_ALREADY_FOLLOWING":
      return {
        ...state,
        alreadyFollowingChecked: false,
        alreadyFollowing: null
      };
    default:
      return state;
  }
};

export default supportReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/supportReducer.tsx